import { MARKET, TMarket } from '@/common/constants/markets';
import { TaxId, TaxIdType } from '@/common/types/general';
import { StringUtils } from '@/common/utils/string';

export const formatCodiceFiscale = (value: string) => {
  const chunks = value.match(/(.{3})(.{3})(.{5})(.{5})/) ?? [];
  const [, ...groups] = chunks; // first item is the full match
  return groups?.join(' ') ?? '';
};

export const formatTaxId = (taxId?: TaxId, fallback = '') => {
  if (!taxId) {
    return fallback;
  }
  switch (taxId.type) {
    case 'nif':
      return StringUtils.formatValueByChunks(taxId.value);
    case 'cf':
      return formatCodiceFiscale(taxId.value);
    default:
      return taxId.value;
  }
};

export const determineTaxIdTypeByMarket = (market: TMarket): TaxIdType => {
  switch (market) {
    case MARKET.IT:
      return 'cf';
    case MARKET.ES:
      return 'es_dni';
    case MARKET.PT:
    default:
      return 'nif';
  }
};

export const TaxUtils = {
  formatCodiceFiscale,
  formatTaxId,
  determineTaxIdTypeByMarket,
};
